import { defineMessages } from 'react-intl';

export default defineMessages({
  read: {
    id: 'Partner.PartnerItem.read',
    defaultMessage: 'Детальніше',
  },
});
